<template>
  <div class="box">
    <img src="@/assets/404@2x.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "blank",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.box {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: url("../../assets/datibgc.png") no-repeat center center;
  background-size: 100%;
}
img {
  width: 459px;
  height: 236px;
  padding-top: 40%;
}
</style>